const BASE_ROUTE = "/onboarding/questionnaire";

export const QUESTIONNAIRE_ROUTE = {
  BASE: BASE_ROUTE,
  MEASUREMENTS: `${BASE_ROUTE}/measurements`,
  PERSONAL_INFO: `${BASE_ROUTE}/personal-info`,
  INTAKE: `${BASE_ROUTE}/intake`,
  PERSONAL_DETAILS: `${BASE_ROUTE}/personal-details`,
  CONTACT_DETAILS: `${BASE_ROUTE}/contact-details`,
  PRODUCT: `${BASE_ROUTE}/product`,
  CHECKOUT: `${BASE_ROUTE}/checkout`,
} as const;

export const QUESTIONNAIRE_STEPS = [
  QUESTIONNAIRE_ROUTE.MEASUREMENTS,
  QUESTIONNAIRE_ROUTE.PERSONAL_INFO,
  QUESTIONNAIRE_ROUTE.INTAKE,
  QUESTIONNAIRE_ROUTE.PERSONAL_DETAILS,
  QUESTIONNAIRE_ROUTE.CONTACT_DETAILS,
  QUESTIONNAIRE_ROUTE.PRODUCT,
  QUESTIONNAIRE_ROUTE.CHECKOUT,
] as const;
